const FR = [
    {
        administrative: 'Île-de-France',
        country: 'France',
        countryCode: 'fr',
        latlng: {lat: 48.8546, lng: 2.3477},
        name: 'Paris',
        postcode: '75000',
        type: 'city',
        value: 'Paris, France',
    },
    {
        administrative: "Provence-Alpes-Côte d'Azur",
        country: 'France',
        countryCode: 'fr',
        county: 'Bouches-du-Rhône',
        latlng: {lat: 43.2954, lng: 5.3631},
        name: 'Marseille',
        postcode: '13000',
        type: 'city',
        value: 'Marseille, France',
    },
    {
        administrative: 'Auvergne-Rhône-Alpes',
        country: 'France',
        countryCode: 'fr',
        county: 'Rhône',
        latlng: {lat: 45.7539, lng: 4.84699},
        name: 'Lyon',
        postcode: '69000',
        type: 'city',
        value: 'Lyon, France',
    },
    {
        administrative: 'Occitanie',
        country: 'France',
        countryCode: 'fr',
        county: 'Haute-Garonne',
        latlng: {lat: 43.6043, lng: 1.44199},
        name: 'Toulouse',
        postcode: '31000',
        type: 'city',
        value: 'Toulouse, France',
    },
];

const ES = [
    {
        administrative: 'Comunidad de Madrid',
        country: 'España',
        countryCode: 'es',
        county: 'Área metropolitana de Madrid y Corredor del Henares',
        latlng: {lat: 40.4167, lng: -3.70358},
        name: 'Madrid',
        postcode: '28001',
        type: 'city',
        value: 'Madrid, España',
    },
    {
        administrative: 'Catalunya',
        country: 'España',
        countryCode: 'es',
        county: 'Barcelonés',
        latlng: {lat: 41.3829, lng: 2.17743},
        name: 'Barcelona',
        postcode: '08001',
        type: 'city',
        value: 'Barcelona, España',
    },
    {
        administrative: 'Andalucía',
        country: 'España',
        countryCode: 'es',
        latlng: {lat: 37.3886, lng: -5.99534},
        name: 'Sevilla',
        postcode: '41001',
        type: 'city',
        value: 'Sevilla, España',
    },
    {
        administrative: 'Comunitat Valenciana',
        country: 'España',
        countryCode: 'es',
        county: 'Comarca de Valencia',
        latlng: {lat: 39.4699, lng: -0.375951},
        name: 'Valencia',
        postcode: '46001',
        type: 'city',
        value: 'Valencia, España',
    },
];

const DE = [
    {
        country: 'Deutschland',
        countryCode: 'de',
        latlng: {lat: 52.517, lng: 13.3889},
        name: 'Berlin',
        postcode: '10115',
        type: 'city',
        value: 'Berlin, Deutschland',
    },
    {
        administrative: 'Bayern',
        country: 'Deutschland',
        countryCode: 'de',
        county: 'Upper Bavaria',
        latlng: {lat: 48.1371, lng: 11.5754},
        name: 'München',
        postcode: '80331',
        type: 'city',
        value: 'München, Deutschland',
    },
    {
        country: 'Deutschland',
        countryCode: 'de',
        latlng: {lat: 53.5503, lng: 10.0007},
        name: 'Hamburg',
        postcode: '20038',
        type: 'city',
        value: 'Hamburg, Deutschland',
    },
    {
        administrative: 'Nordrhein-Westfalen',
        country: 'Deutschland',
        countryCode: 'de',
        county: 'Regierungsbezirk Köln',
        latlng: {lat: 50.9384, lng: 6.95997},
        name: 'Köln',
        postcode: '50667',
        type: 'city',
        value: 'Köln, Deutschland',
    },
];

export {FR, ES, DE};
